<template>
  <div class="jps-rights-popup">
    <div class="jps-license-title">
      <span>
        <BaseIcon name="mdi/help-circle-outline" class="is-hidden-mobile" />
        {{ lc(rightsCode, rights) }}
      </span>
      <h2 class="is-size-6">{{ ls(getRightDescription(rights)) }}</h2>
    </div>
    <div class="jps-license">
      <UiRightsLicenseSummary :rights="rights" />
    </div>
    <div>
      <p class="description is-size-7" v-shtml="description" />
      <div class="description-link" v-if="rightsLink">
        <UiButtonLinkRound :url="rightsLink" styled="primary">
          {{ lss('詳細', 'Details') }}
        </UiButtonLinkRound>
      </div>
    </div>
    <div class="jps-condition" v-if="!isEmpty(rightsDescription)">
      <h3 class="is-size-6">{{ lss('資料固有の条件', 'Condition') }}</h3>
      <p class="is-size-7" v-shtml="ls(rightsDescription)"></p>
    </div>
    <div class="jps-condition" v-if="data">
      <h3 class="is-size-6">{{ lss('出典の記載例', 'Reference') }}</h3>
      <Citation :type="type" :data="data" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import vShtml from '~/directives/shtml'
import { useRightsData } from '~/components/ui/rights/useRightsData'

const { ls, lss, lc, isJa } = useI18n()
const { $getCodeRightsType } = useNuxtApp()
const { getRightDescription } = useRightsData()

interface Props {
  rights: string,
  rightsDescription?: LangString,
  type?: Key | null,
  data?: { id: string },
}
const props = withDefaults(defineProps<Props>(),{
})

const rightsLink = computed(() => {
  if (isJa.value) {
    return getRightDescription(props.rights).urlJa
  } else {
    return getRightDescription(props.rights).urlEn
  }
})

//data
const rightsCode: Code = $getCodeRightsType()

const description = computed(() => {
  if (props.rights) {
    return ls(
      rightsCode.values.filter((c) => c.code === props.rights)[0].description
    )
  }
})
</script>

<style lang="scss">
@use '@/assets/styles/scss/vue' as *;

.jps-rights-popup {
  max-width: 22rem;
  max-height: 26rem;
  background-color: $jps-gray-50;
  color: $black !important;
  @include is-mobile() {
    max-width: 22rem;
    max-height: 90vh;
  }
  @include is-tablet() {
    padding: 1rem;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .jps-rights-summary-ok {
    color: $jps-key-green;
  }
  .jps-rights-summary-conditional {
    color: $jps-sub-orange;
  }
  .jps-rights-summary-ng {
    color: $jps-key-red;
  }
  .jps-rights-summary-na {
    color: $jps-gray-600;
  }
  .jps-key-blue {
    color: $jps-key-blue;
  }

  .copyright-global {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 0;
    h2 {
      margin: 0;
      @include is-mobile {
        margin-bottom: 0.5rem;
      }
    }
    > p {
      margin: 0.75rem 0;
      line-height: inherit;
    }
    .jps-icon {
      font-size: 4.5rem;
      padding-right: 1rem;
      @include is-mobile {
        font-size: 1.5rem;
        padding-right: 0;
      }
    }
  }
  .jps-license-title {
    color: $jps-gray-800;
    > span {
      display: flex;
      align-items: center;
      span {
        margin-right: 0.125rem;
      }
    }
    h2 {
      margin-top: 0.25rem;
    }
  }
  .jps-license {
    /* padding-left: 5.5rem; */
    /* padding-bottom: 3rem; */
    margin: 1rem auto;
    @include is-mobile {
      padding-bottom: 2rem;
    }
  }
  .jps-condition {
    margin: 0.5rem auto;
    color: $jps-gray-800;
    .jps-citation p.citation-body {
      color: $jps-gray-800;  // Citationで白文字になっているので上書き
    }
    p, p a {
      overflow-wrap: anywhere;
    }
  }
  .guideline {
    background: $white;
    justify-content: center;
    @include is-tablet {
      display: flex;
      align-items: stretch;
    }

    .guideline-contents {
      display: flex;
      justify-content: center;
      @include is-mobile {
        margin: 0.5rem auto;
      }
      .jps-icon {
        display: block;
        font-size: 3rem;
        cursor: pointer;
      }
      > div {
        min-width: 6.75rem;
        .heading {
          margin-bottom: 0.5rem;
          letter-spacing: 0;
        }
      }
    }
    .guideline-details {
      @include is-tablet {
        padding-left: 0;
      }
    }
  }

  .description-link {
    text-align: right;
  }
}
</style>
